import axios from "axios";

export default {
    state: () => ({
        accessLogsResponse : null,
        endpointStatsList : null,
    }),
    mutations: {
        setAccessLogsResponse:function (state,accessLogsResponse){
            state.accessLogsResponse = accessLogsResponse;
        },
        setEndpointStatsList:function (state,endpointStatsList){
            state.endpointStatsList = endpointStatsList;
        },
    },
    getters: {
        getAccessLogsResponse : state => {
            return state.accessLogsResponse
        },
        getEndpointStatsList : state => {
            return state.endpointStatsList
        },
    },
    actions:{
        loadAccessLogs(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(
                context.getters.getServiceUrl + "/admin-api/access-logs?page="+request.page+
                "&searchTerm="+request.searchTerm+
                "&searchAreas="+request.searchAreas
                ,{headers})
                .then((response) => {
                    context.commit("setAccessLogsResponse", response.data);
                    return response.data.items;
                })
        },
        loadEndpointStats(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(
                context.getters.getServiceUrl + "/admin-api/access-logs/endpoint-stats"
                ,{headers})
                .then((response) => {
                    context.commit("setEndpointStatsList", response.data);
                    return response.data;
                })
        }
    }
}